import { ObjectSchema, array, number, object, string } from "yup";
import { SubmitProgramReport } from "../../../../../generated/data-contracts";
import { ResCallback } from "../../../../../models";
import {
  fileCollectionValidation,
  numberInteger,
  requiredClassifierId,
  requiredNumber,
  requiredString,
  simpleString,
  stringTiming,
} from "../../../../../data/yupConstants";

export const validationClientEventProgramReport = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  res: ResCallback,
  uploadableFileTypes: string[] | undefined,
  unsupportedSymbols: string[],
  maxFileSize: number,
): ObjectSchema<SubmitProgramReport> | undefined => {
  const validationSchema: ObjectSchema<SubmitProgramReport> = object({
    eventLocation: string(),
    portal_LicenseProgramReportId: number(),
    programReportRows: array().of(validationCreationsIdentifiedRow(res)),
    dataFileRows: fileCollectionValidation(
      res,
      uploadableFileTypes,
      unsupportedSymbols,
      maxFileSize,
      true,
    ),
    creationsUnidentifiedRows: array().of(
      validationCreationsUnidentifiedRow(res),
    ),
  });

  return validationSchema;
};
export const validationCreationsIdentifiedRow = (res: ResCallback) =>
  object().shape({
    portal_LicenseProgramReportLineId: number(),
    creationId: requiredNumber(res),
    creationClassId: requiredNumber(res),
    creationInfo: object().shape({
      creationId: number(),
      creationNameToDisplay: string(),
      rightsHolderNamesProgramReportForm: string(),
      creationClassId: number(),
      creationClassName: string(),
      bandsToDisplay: string(),
    }),
    playLength: stringTiming(res).required(res("validation_FieldIsRequired")),
    playCount: numberInteger(res, true, true),
    rowVersion: string(),
  });

export const validationCreationsUnidentifiedRow = (res: ResCallback) =>
  object().shape({
    creationsUnidentifiedId: number(),
    creationClassId: requiredClassifierId(res),
    creationName: requiredString(res, 2, 200),
    composer: simpleString(res, 2, 250),
    performer: simpleString(res, 2, 250),
    textAuthor: simpleString(res, 2, 250),
    coFounder: simpleString(res, 2, 250),
    choreographer: simpleString(res, 2, 250),
    playLength: stringTiming(res).required(res("validation_FieldIsRequired")),
    playCount: numberInteger(res, true, true),
    rowVersion: string(),
    notes: simpleString(res, undefined, 500),
  });
